const url = process.env.REACT_APP_API_URL;

export default class RapportServices {

    constructor() {
        this.url = process.env.REACT_APP_API_URL;
    }

    static getRapport() {
        return fetch(`${url}/rapport`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addRapport(rapport) {
        return fetch(`${url}/rapport`, {
            method: 'POST',
            body: JSON.stringify(rapport),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateRapport(rapport) {
        return fetch(`${url}/rapport`, {
            method: 'PUT',
            body: JSON.stringify(rapport),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteRapport(rapport) {
        return fetch(`${url}/rapport`, {
            method: 'DELETE',
            body: JSON.stringify(rapport),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}